import React from "react";

const LoadingOverlay = ({ message = "Loading..." }) => (
    <div
        style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            borderRadius: '8px'
        }}
    >
        <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
        <div style={{ fontSize: '14px', color: '#666', fontWeight: '500' }}>
            {message}
        </div>
    </div>
);

export default LoadingOverlay;